<div class="tw-h-full tw-w-full tw-overflow-hidden">
  <div class="tw-flex tw-flex-col tw-h-full">
    @if (loading) {
      <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
    }

    @if (!loading) {
      <!-- Single scroll container: header scrolls away, tabs stick -->
      <div class="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-relative">
        <!-- Header: sticky when no tabs so child content has no gap -->
        <div class="tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]"
             [ngClass]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025, 'tw-sticky tw-top-0': !showTabs}">
          <div class="tw-fixed tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10 tw-z-20"
               (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
          </div>
          <span class="tw-font-bold tw-text-300 tw-text-white"
                [ngClass]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}"
                >{{ headerTitle }}</span>
        </div>

        <!-- Tabs: only shown when 2+ eligible tabs -->
        <!-- Tabs: content projected into sequential slots based on visibility order -->
        @if (showTabs) {
          <toolbar-tabs class="tw-sticky tw-top-0 tw-z-10 tw-w-full"
                        (tabSelected)="tabChange($event)"
                        [data]="tabData"
                        [shouldFormatTabData]="true"
                        [acqRebranding2025]="acqRebranding2025">
            <tab1 class="tw-uppercase">
              @switch (visibleTabLabels[0]) {
                @case ('face') { <span i18n="@@face">Face</span> }
                @case ('hair') { <span i18n="@@hair">Hair</span> }
                @case ('others') { <span i18n="@@others">Others</span> }
              }
            </tab1>
            @if (visibleTabLabels.length >= 2) {
              <tab2 class="tw-uppercase">
                @switch (visibleTabLabels[1]) {
                  @case ('face') { <span i18n="@@face">Face</span> }
                  @case ('hair') { <span i18n="@@hair">Hair</span> }
                  @case ('others') { <span i18n="@@others">Others</span> }
                }
              </tab2>
            }
            @if (visibleTabLabels.length >= 3) {
              <tab3 class="tw-uppercase">
                @switch (visibleTabLabels[2]) {
                  @case ('face') { <span i18n="@@face">Face</span> }
                  @case ('hair') { <span i18n="@@hair">Hair</span> }
                  @case ('others') { <span i18n="@@others">Others</span> }
                }
              </tab3>
            }
          </toolbar-tabs>
        }

        <!-- Content — child participates in the same scroll flow -->
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
